'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Base = require('../Base');

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Trash = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Trash, _Component);

  function Trash() {
    (0, _classCallCheck3.default)(this, Trash);
    return (0, _possibleConstructorReturn3.default)(this, (Trash.__proto__ || (0, _getPrototypeOf2.default)(Trash)).apply(this, arguments));
  }

  (0, _createClass3.default)(Trash, [{
    key: 'render',
    value: function render() {
      var props = (0, _extends3.default)({}, this.props, {
        width: parseInt(this.props.width, 10),
        height: parseInt(this.props.height, 10)
      });

      return _react2.default.createElement(
        _Base2.default,
        (0, _extends3.default)({ viewBox: '0 0 123.7 123.7' }, props),
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { fill: props.fillTrash1 || props.fill, d: 'M23.298,44.5c-0.1,0-0.1,0-0.2,0v73.2c0,3.3,2.7,6,6,6h65.5c3.3,0,6-2.7,6-6c0,0-0.1-73.2-0.2-73.2H23.298z M44.499,103   c0,2.801-2.2,5-5,5c-2.8,0-5-2.199-5-5V64.4c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5V103z M66.898,103c0,2.801-2.2,5-5,5s-5-2.199-5-5   V64.4c0-2.8,2.2-5,5-5s5,2.2,5,5V103z M89.298,103c0,2.801-2.199,5-5,5c-2.799,0-5-2.199-5-5V64.4c0-2.8,2.201-5,5-5   c2.801,0,5,2.2,5,5V103z' }),
          _react2.default.createElement('path', { fill: props.fillTrash2 || props.fill, d: 'M100.499,20.1h-5.4h-5.4c-1.699,0-3-1.3-3-3V6.2c0-3.4-2.8-6.2-6.199-6.2H43.298c-3.4,0-6.2,2.8-6.2,6.2V17   c0,1.7-1.3,3-3,3h-5.4h-5.4c-3.4,0-6.2,2.8-6.2,6.2v2.1c0,3.4,2.7,6.1,6,6.2c0.1,0,0.1,0,0.2,0h77.1c0.101,0,0.101,0,0.2,0   c3.3-0.1,6-2.8,6-6.2v-2.1C106.698,22.8,103.898,20.1,100.499,20.1z M76.398,20L76.398,20h-28.9l0,0v-6.6c0-1.7,1.4-3.1,3.1-3.1   h22.699c1.701,0,3.101,1.4,3.101,3.1V20z' })
        )
      );
    }
  }]);
  return Trash;
}(_react.Component), _class.propTypes = {
  width: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  height: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  fill: _react.PropTypes.string,
  fillTrash1: _react.PropTypes.string,
  fillTrash2: _react.PropTypes.string,
  className: _react.PropTypes.string
}, _class.defaultProps = {
  width: 16,
  height: 16,
  fill: '#848484'
}, _temp);
exports.default = Trash;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseIcons/Trash/Trash.jsx
// module id = 1595
// module chunks = 0